import { default as _91_46_46_46slug_93HJmYAfZ7GLMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue?macro=true";
import { default as _91id_93e4hPmkzhdRMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue?macro=true";
import { default as bathroomsNJPaP0byqAMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue?macro=true";
import { default as buy_45ticketsJ1z64z7OaEMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue?macro=true";
import { default as eventsGB1SL5sIPIMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue?macro=true";
import { default as ever_45newpvvLiPKKrMMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue?macro=true";
import { default as everaOo98XPfPAMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue?macro=true";
import { default as faqs2Tgz2B1Fz4Meta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue?macro=true";
import { default as in_45the_45newshAEwvbKCrpMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue?macro=true";
import { default as indexDUFsZDPxDLMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue?macro=true";
import { default as new_45years_45eve_45headquarters7BmXofpmFjMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue?macro=true";
import { default as next_45genLZjOw37gnkMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue?macro=true";
import { default as nye_45ball_45crystal_45vip_45experienceZe6RvgYYVgMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue?macro=true";
import { default as plan_45your_45visitVnGS0qNJECMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue?macro=true";
import { default as privacy_45policyfDkTEX5PC1Meta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue?macro=true";
import { default as profileagoRCEnHzuMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue?macro=true";
import { default as times_45travelmHfGfOuhiuMeta } from "/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue?macro=true";
export default [
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___zh",
    path: "/zh/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___hi",
    path: "/hi/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___pt",
    path: "/pt/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___ja",
    path: "/ja/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "slug___ko",
    path: "/ko/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/[...slug].vue")
  },
  {
    name: "article-id___en",
    path: "/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___fr",
    path: "/fr/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___es",
    path: "/es/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___zh",
    path: "/zh/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___hi",
    path: "/hi/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___de",
    path: "/de/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___nl",
    path: "/nl/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___pt",
    path: "/pt/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___it",
    path: "/it/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___ja",
    path: "/ja/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "article-id___ko",
    path: "/ko/article/:id()",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/article/[id].vue")
  },
  {
    name: "bathrooms___en",
    path: "/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___fr",
    path: "/fr/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___es",
    path: "/es/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___zh",
    path: "/zh/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___hi",
    path: "/hi/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___de",
    path: "/de/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___nl",
    path: "/nl/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___pt",
    path: "/pt/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___it",
    path: "/it/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___ja",
    path: "/ja/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "bathrooms___ko",
    path: "/ko/bathrooms",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/bathrooms.vue")
  },
  {
    name: "buy-tickets___en",
    path: "/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___fr",
    path: "/fr/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___es",
    path: "/es/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___zh",
    path: "/zh/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___hi",
    path: "/hi/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___de",
    path: "/de/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___nl",
    path: "/nl/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___pt",
    path: "/pt/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___it",
    path: "/it/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___ja",
    path: "/ja/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "buy-tickets___ko",
    path: "/ko/buy-tickets",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/buy-tickets.vue")
  },
  {
    name: "events___en",
    path: "/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___fr",
    path: "/fr/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___es",
    path: "/es/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___zh",
    path: "/zh/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___hi",
    path: "/hi/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___de",
    path: "/de/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___nl",
    path: "/nl/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___pt",
    path: "/pt/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___it",
    path: "/it/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___ja",
    path: "/ja/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "events___ko",
    path: "/ko/events",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/events.vue")
  },
  {
    name: "ever-new___en",
    path: "/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___fr",
    path: "/fr/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___es",
    path: "/es/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___zh",
    path: "/zh/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___hi",
    path: "/hi/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___de",
    path: "/de/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___nl",
    path: "/nl/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___pt",
    path: "/pt/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___it",
    path: "/it/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___ja",
    path: "/ja/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever-new___ko",
    path: "/ko/ever-new",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever-new.vue")
  },
  {
    name: "ever___en",
    path: "/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___fr",
    path: "/fr/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___es",
    path: "/es/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___zh",
    path: "/zh/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___hi",
    path: "/hi/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___de",
    path: "/de/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___nl",
    path: "/nl/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___pt",
    path: "/pt/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___it",
    path: "/it/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___ja",
    path: "/ja/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "ever___ko",
    path: "/ko/ever",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/ever.vue")
  },
  {
    name: "faqs___en",
    path: "/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___fr",
    path: "/fr/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___es",
    path: "/es/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___zh",
    path: "/zh/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___hi",
    path: "/hi/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___de",
    path: "/de/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___nl",
    path: "/nl/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___pt",
    path: "/pt/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___it",
    path: "/it/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___ja",
    path: "/ja/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "faqs___ko",
    path: "/ko/faqs",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/faqs.vue")
  },
  {
    name: "in-the-news___en",
    path: "/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___fr",
    path: "/fr/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___es",
    path: "/es/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___zh",
    path: "/zh/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___hi",
    path: "/hi/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___de",
    path: "/de/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___nl",
    path: "/nl/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___pt",
    path: "/pt/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___it",
    path: "/it/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___ja",
    path: "/ja/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "in-the-news___ko",
    path: "/ko/in-the-news",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/in-the-news.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/index.vue")
  },
  {
    name: "new-years-eve-headquarters___en",
    path: "/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___fr",
    path: "/fr/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___es",
    path: "/es/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___zh",
    path: "/zh/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___hi",
    path: "/hi/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___de",
    path: "/de/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___nl",
    path: "/nl/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___pt",
    path: "/pt/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___it",
    path: "/it/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___ja",
    path: "/ja/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "new-years-eve-headquarters___ko",
    path: "/ko/new-years-eve-headquarters",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/new-years-eve-headquarters.vue")
  },
  {
    name: "next-gen___en",
    path: "/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___fr",
    path: "/fr/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___es",
    path: "/es/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___zh",
    path: "/zh/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___hi",
    path: "/hi/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___de",
    path: "/de/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___nl",
    path: "/nl/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___pt",
    path: "/pt/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___it",
    path: "/it/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___ja",
    path: "/ja/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "next-gen___ko",
    path: "/ko/next-gen",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/next-gen.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___en",
    path: "/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___fr",
    path: "/fr/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___es",
    path: "/es/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___zh",
    path: "/zh/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___hi",
    path: "/hi/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___de",
    path: "/de/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___nl",
    path: "/nl/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___pt",
    path: "/pt/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___it",
    path: "/it/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___ja",
    path: "/ja/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "nye-ball-crystal-vip-experience___ko",
    path: "/ko/nye-ball-crystal-vip-experience",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/nye-ball-crystal-vip-experience.vue")
  },
  {
    name: "plan-your-visit___en",
    path: "/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___fr",
    path: "/fr/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___es",
    path: "/es/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___zh",
    path: "/zh/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___hi",
    path: "/hi/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___de",
    path: "/de/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___nl",
    path: "/nl/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___pt",
    path: "/pt/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___it",
    path: "/it/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___ja",
    path: "/ja/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "plan-your-visit___ko",
    path: "/ko/plan-your-visit",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/plan-your-visit.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___zh",
    path: "/zh/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___hi",
    path: "/hi/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___de",
    path: "/de/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___nl",
    path: "/nl/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___pt",
    path: "/pt/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ja",
    path: "/ja/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ko",
    path: "/ko/privacy-policy",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/privacy-policy.vue")
  },
  {
    name: "profile___en",
    path: "/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___fr",
    path: "/fr/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___es",
    path: "/es/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___zh",
    path: "/zh/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___hi",
    path: "/hi/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___de",
    path: "/de/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___nl",
    path: "/nl/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___pt",
    path: "/pt/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___it",
    path: "/it/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___ja",
    path: "/ja/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "profile___ko",
    path: "/ko/profile",
    meta: profileagoRCEnHzuMeta || {},
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/profile.vue")
  },
  {
    name: "times-travel___en",
    path: "/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___fr",
    path: "/fr/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___es",
    path: "/es/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___zh",
    path: "/zh/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___hi",
    path: "/hi/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___de",
    path: "/de/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___nl",
    path: "/nl/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___pt",
    path: "/pt/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___it",
    path: "/it/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___ja",
    path: "/ja/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  },
  {
    name: "times-travel___ko",
    path: "/ko/times-travel",
    component: () => import("/home/vsts/work/1/s/webapp-ots-nuxt/pages/times-travel.vue")
  }
]